<template>
  <v-container>
    <div style="display:flex;">
      <h1>VERNERUNDE</h1>
      <v-spacer></v-spacer>
      <v-btn href="https://innherred.sharepoint.com/sites/innsia-verdal/Profil/Forms/AllItems.aspx?viewid=b1664275%2D98ca%2D4df7%2Dbf1e%2D91c1262615f5&FolderCTID=0x01200009B23678C98E5043B75898A5DECE1FCC&id=%2Fsites%2Finnsia%2Dverdal%2FProfil%2FOrganisasjonsplattform%2FOrganisasjonsplattform%201%2Epdf&parent=%2Fsites%2Finnsia%2Dverdal%2FProfil%2FOrganisasjonsplattform" target="_blank">Organisasjonsplattform</v-btn>
      <v-btn href="https://x09.ksx.no/system.php?item=126359&ok=tr4djpn6g0y1s83" target="_blank">Arbeidsreglement</v-btn>
      <v-btn href="https://x09.ksx.no/system.php?item=117963&ok=tr4djpn6g0y1s83" target="_blank">Etiske retningslinjer</v-btn>
      <v-btn href="https://x09.ksx.no/system.php?item=123520&ok=tr4djpn6g0y1s83" target="_blank">retningslinjer for trafikk</v-btn>
      <v-btn href="https://x09.ksx.no/system.php?item=120118&ok=tr4djpn6g0y1s83#docContentList120118x1770207407ClAnchor4" target="_blank">Prosedyre Vold & Trusler</v-btn>
    </div>
    <v-tabs v-model="activeTab">
      <v-tab><a href="https://innherred.sharepoint.com/:w:/s/Personal585/IQDuv72Yo1IsSZrujY_4_wtjATu9TEJk2gAmvOtttowrSmo?e=qV56ME" target="_blank">Info</a></v-tab>
      <v-tab ripple>Vernerunden</v-tab>
      <v-tab ripple>Tiltaksvurdering</v-tab>
    <v-tab-item></v-tab-item>
      <!-- SKJEMA -->
       <v-btn color="blue lighten-2" text @click="newVernerunde">
        Ny Vernerunde
      </v-btn>
    <v-tab-item>
      <div class="form-wrapper">
        <div v-if="loadingDialog">{{ loadingDialogText }}</div>
        <div v-else-if="!questions.length">Ingen spørsmål funnet.</div>
        <template v-else>
          <div v-for="(categoryQuestions, categoryName, categorySerialNumber) in groupedQuestions" :key="categoryName" class="mb-4">
            <v-subheader class="category">{{ categoryName }}</v-subheader>
            <v-list>
              <template v-for="q in categoryQuestions" >
                <v-list-tile :key="q.id">
                  <v-list-tile-content v-if="q.positive === 'HLP'">
                    <v-subheader>{{ q.text }}</v-subheader>
                  </v-list-tile-content>

                  <template v-else class="d-flex flex-wrap">
                    <v-list-tile-content>
                      {{q.serial_number}} - {{ q.text }}
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn-toggle :value="selectedResponses[q.id]">
                        <v-btn
                          value="JA"
                          large
                          :color="q.positive === 'JA' ? 'green' : 'red'"
                          :depressed="selectedResponses[q.id] !== 'JA'"
                          :outlined="selectedResponses[q.id] !== 'JA'"
                          @click="() => setAnswer(q.id, 'JA')"
                        >JA</v-btn>

                        <v-btn
                          value="NEI"
                          large
                          class="ml-2"
                          :color="q.positive === 'NEI' ? 'green' : 'red'"
                          :depressed="selectedResponses[q.id] !== 'NEI'" 
                          :outlined="selectedResponses[q.id] !== 'NEI'"
                          @click="() => setAnswer(q.id, 'NEI')"
                        >NEI</v-btn>
                        <v-btn
                          value="NA"
                          large
                          class="ml-2"
                          :color="'yellow'"
                          :depressed="selectedResponses[q.id] !== 'NA'" 
                          :outlined="selectedResponses[q.id] !== 'NA'"
                          @click="() => setAnswer(q.id, 'NA')"
                        >Ikke aktuelt</v-btn>
                      </v-btn-toggle>
                    </v-list-tile-action>
                  </template>
                </v-list-tile>
              </template>
            </v-list>
          </div>
        </template>
        <div v-if="registeredChanges" style="margin-left:auto;display:flex" class="buttonwrapper">
          <v-btn color="success" @click="saveResponse">Lagre</v-btn>
        </div>
      </div>
    </v-tab-item>
    <!-- RISIKOANALYSE -->
    <v-tab-item>
    <v-data-table
      :items="sortedNegativeResponses"
      hide-actions
      group-by="category"
    >
      <template v-slot:headers>
        <th style="width: 15%" align="left">Kategori</th>
        <th style="width: 25%;" align="left">Spørsmål</th>
        <th style="width: 3%;" align="left">Svar</th>
        <th style="width: 10%; white-space: normal;" align="left">
          Sannsynlighet for hendelse
          <v-icon class="ml-3" @click="probabilityDialog = true">help</v-icon>
        </th>
        <th style="width: 10%; white-space: normal;" align="left">
          Alvorlighet ved hendelse
          <v-icon class="ml-3" @click="consequenceDialog = true">help</v-icon>
        </th>
        <th style="width: 1%;" align="left">Produkt</th>
        <th style="width: auto;" align="left">
          Tiltak
          <v-icon class="ml-2" @click="helpDialog = true">help</v-icon>
        </th>
      </template>
      <template v-slot:no-data>
        <td colspan="5" class="pa-0">
          <v-alert
            class="black--text ma-0"
            :value="true"
            color="primary lighten-2"
            icon="info"
            >Ingen aktiviteter registrert enda</v-alert
          >
        </td>
      </template>
      <template v-slot:items="props">
        <tr class="activities">
          <td><strong>{{props.item.serial_number}} - {{ props.item.category }}</strong></td>
          <td>{{ props.item.question }}</td>
          <td>{{ props.item.response }}</td>
          <td>
            <v-select
              :items="probabilityRange"
              v-model="props.item.likelihood"
              single-line
              class="text-h6"
            ></v-select>
          </td>
          <td>
            <v-select
              :items="consequenceRange"
              v-model="props.item.consequence"
              single-line
            ></v-select>
          </td>
          <td :class="{'high-risk': props.item.product >= threshhold}">{{ calculateProduct(props.item) }}</td>
          <td>
            <v-text-field
              v-model="props.item.measure">
              {{ props.item.measure || 'Legg til tiltak' }}
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.measure"
                  label="Beskriv tiltak"
                  single-line
                ></v-text-field>
              </template>
            </v-text-field>
          </td>
        </tr>
      </template>
    </v-data-table>
          <v-btn color="success" @click="saveNewActivities">Lagre</v-btn>
    </v-tab-item>
    </v-tabs>
      <v-dialog v-model="helpDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="text-h5"><h2>Her skal du sette tiltak som skal inn i handlingsplanen.</h2></span>
          </v-card-title>
          <v-card-text>
            <p>Hva er det dere skal jobbe med ift risikoen som dere har kartlagt?</p>
            <p>Hvis dere har tiltaket klart, så skriver dere inn det.</p>
            <p>Det kan ofte ende med en ROS analyse av problemstillingen. Da skriver dere det.</p>
            <p>Selve ROS analysen gjør dere i ROS modul i Compilo.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="helpDialog = false">
              Lukk
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="probabilityDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="text-h5"><h2>Sannsynlighet (Hvor ofte?)</h2></span>
          </v-card-title>
          <v-card-text>
            <p>Skalaen indikerer hvor sannsynlig det er at en hendelse inntreffer:</p>
              
              <p>1 - Svært lite sannsynlig: Skjer nesten aldri (f.eks. mer enn 5 år mellom hver gang).</p>
              <p>2 - Lite sannsynlig: Skjer sjelden (f.eks. 3-5 år).</p>
              <p>3 - Moderat sannsynlig/Mulig: Kan skje (f.eks. 1-3 år).</p>
              <p>4 - Sannsynlig: Skjer ofte (f.eks. innen 1 år).</p>
              <p>5 - Svært sannsynlig/</p> 
            </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="probabilityDialog = false">
              Lukk
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
            <v-dialog v-model="consequenceDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="text-h5"><h2>Konsekvens (Hvor alvorlig?)</h2></span>
          </v-card-title>
          <v-card-text>
            <p>Skalaen indikerer alvorlighetsgraden dersom hendelsen inntreffer (helse, miljø, økonomi):</p>

              <p>1 - Svært liten: Ubetydelig. Ingen skade eller kun bagatellmessig skade/økonomisk tap.</p>
              <p>2 - Liten: Mindre skade/avbrudd. Grunnleggende førstehjelp, mindre økonomisk tap.</p>
              <p>3 - Middels: Merkbar effekt. Skade som krever legebehandling, merkbart økonomisk tap eller driftsstans.</p>
              <p>4 - Stor: Alvorlig. Betydelig skade/ulykke, stort økonomisk tap, brudd på regelverk.</p>
              <p>5 - Svært stor: Katastrofal. Dødsfall, permanent invaliditet, virksomhetskritisk svikt.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="consequenceDialog = false">
              Lukk
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-container>
  <!-- <v-form v-model="questions">
    <template v-slot:items="props">
      <div>{{ props.item.text }}</div>
    </template> 
  </v-form>
   -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ref } from 'vue'

export default {
  methods: {
    ...mapActions(["GET_VERNERUNDE", "SUBMIT_VERNERUNDE_RESPONSE", "GET_USER_PLAN", "GET_RESPONSES"]),
    syncLoadedResponses() {
      if (!Array.isArray(this.questions) || !Array.isArray(this.responses)) return;

      const questionById = new Map(this.questions.map(q => [q.id, q]));
      const selected = {};
      const negatives = [];

      for (const r of this.responses) {
        if (!r || r.question_id == null) continue;

        selected[r.question_id] = r.response;

        const q = questionById.get(r.question_id);
        if (!q || q.positive === 'HLP') continue;

        if (r.response !== q.positive && r.response !== 'NA') {
          negatives.push({
            question_id: q.id,
            category: q.category,
            actualCategory: q.actual_category,
            question: q.text,
            response: r.response,
            serial_number: q.serial_number,
            likelihood: 0,
            consequence: 0,
            product: 0,
            measure: ""
          });
        }
      }

      this.selectedResponses = selected;
      this.negativeResponses = negatives;
    },
    setAnswer(questionId, value) {
      const existingIndex = this.responses.findIndex(r => r.question_id === questionId);
      const hasExisting = existingIndex !== -1;
      const isSameValue = hasExisting && this.responses[existingIndex].response === value;

      // Toggle off if user clicks the same answer again
      if (isSameValue) {
        this.responses.splice(existingIndex, 1);
        this.$delete(this.selectedResponses, questionId);
      } else {
        if (hasExisting) {
          this.responses[existingIndex].response = value;
        } else {
          this.responses.push({ question_id: questionId, response: value });
        }
        this.$set(this.selectedResponses, questionId, value);
      }

      this.registeredChanges = true;

      const currentQuestion = this.questions.find(q => q.id === questionId);
      if (!currentQuestion || currentQuestion.positive === "HLP") return;

      // Remove any existing negative entry for this question
      this.negativeResponses = this.negativeResponses.filter(n => n.question_id !== questionId);

      const selectedValue = this.selectedResponses[questionId];
      console.log('current question: ', currentQuestion)
      if (selectedValue && selectedValue !== currentQuestion.positive && selectedValue !== "NA") {
        this.negativeResponses.push({
          question_id: currentQuestion.id,
          category: currentQuestion.category,
          actualCategory: currentQuestion.actual_category,
          question: currentQuestion.text,
          response: selectedValue,
          serial_number: currentQuestion.serial_number,
          likelihood: 0,
          consequence: 0,
          product: 0,
          measure: ""
        });
      }
    },
    saveResponse() {
      let ResponseData = {
        Transfer: "saveresponse",
        data: {
          ...this.responses,
          vernerunde_id: this.currentVernerunde
          },
        guid: this.$route.params.guid
        };
      this.SUBMIT_VERNERUNDE_RESPONSE( ResponseData ).then((res) => {
        this.registeredchanges = false;
      });

      this.activeTab = 2;
    },

    async saveNewActivities() {
      let _newPlan = await this.GET_USER_PLAN(this.$route.params.guid)

      const responsesThatNeedMeasures = this.negativeResponses.filter((item) => {
        return item.product >= this.threshhold || (item.measure && item.measure.trim() !== '');
      })
      let ResponseData = {
        Transfer: "insertactivities",
        data: {
          ...responsesThatNeedMeasures,
          planningid: _newPlan.data.planning.id,
          responseid: _newPlan.data.response.id,
          organisationid: _newPlan.data.response.organisationid,
          vernerunde_id: this.currentVernerunde
          },
        };
      await this.SUBMIT_VERNERUNDE_RESPONSE(ResponseData)
      .then((res) => {
        this.registeredchanges = false;
      })
 
      // Route to planresponse
      this.$router.push({ name: "planresponse", query: { tab: 'planlegge' }})
    },

    calculateProduct(item) {
      item.product = item.likelihood * item.consequence;
      return item.product
    },
    getQuestions() {
      this.loadingDialogText = "Vennligst vent mens vi henter data";
      this.loadingDialog = true;
      this.GET_VERNERUNDE(this.$route.params.guid)
        .then((res) => {
          this.loadingDialog = false;
          const qs = res && res.data && res.data.questions;
          const questionList = Array.isArray(qs) ? qs : [];
          this.questions = questionList.sort((a,b) => {return a.serial_number - b.serial_number})

      })
        .catch((e) => {
          this.loadingDialog = false;
          console.error(e);
        });
    },
    getResponses() {
      this.loadingDialogText = "Vennligs vent mens vi henter data";
      this.loadingDialog = true;
      this.GET_RESPONSES(this.$route.params.guid /* Organisation ID*/)
        .then((res) => {
          this.loadingDialog = false;
          if(res.data && res.data.length != 0) {
            this.currentVernerunde = (res.data[0].vernerunde_id);
            if(this.currentVernerunde == 0) {
              this.currentVernerunde = 1;
            }
          } else {
            this.currentVernerunde = 1;
          }

         // console.log('get responses result: ', res)
          const resp = res; //Hent responsene fra Datbasen
          const responseList = Array.isArray(resp.data) ? resp.data : []; // Lag ett array av responsene som hentes ned
          /*
          id, org_id, question_id, response, date, planningid, vernerunde_id
          */
         this.responses = responseList // Lagre responsene i this.responses sortert etter question_id
         this.syncLoadedResponses()
        })
    },
    newVernerunde() {
      this.currentVernerunde += 1;
      this.selectedResponses = []
      this.responses = []
    }
  },
  data() {
    return {
      activeTab: 1,
      loadingDialog: false,
      loadingDialogText: "",
      registeredChanges: false,
      questions: [],
      responses: [], // key: question id (or index), value: JA/NEI
      currentVernerunde: 0,
      negativeResponses: [],
      currentPlan: {},
      probabilityRange: [
        {value: 1, text:  "1 - Svært lite sannsynlig"},
        {value: 2, text:  "2 - Lite sannsynlig"},
        {value: 3, text:  "3 - Moderat sannsynlig"},
        {value: 4, text:  "4 - Sannsynlig"},
        {value: 5, text:  "5 - Svært sannsynlig"}
      ],
      consequenceRange: [
        {value: 1, text:  "1 - Svært liten"},
        {value: 2, text:  "2 - Liten"},
        {value: 3, text:  "3 - Middels"},
        {value: 4, text:  "4 - Stor"},
        {value: 5, text:  "5 - Svært stor"}
      ],
      threshhold: 9,
      helpDialog: false,
      probabilityDialog: false,
      consequenceDialog: false,
      selectedResponses: {},
    };
  },
  computed: {
    ...mapGetters(["GET_PLANSFORTHISCUSTOMER", "GET_USER"]),
    // getCurrentPlan() {
    //   this.currentPlan = GET_PLANSFORTHISCUSTOMER()
    //   console.log('current plan: ', this.currentPlan)
    // },
    sortedNegativeResponses() {
      const listCopy = this.negativeResponses;
      return listCopy.sort((a,b) => { return a.serial_number - b.serial_number })
    },

    groupedQuestions() {
      const groups = {};
      if (!this.questions || !Array.isArray(this.questions)) {
        return groups;
      }

      for (const question of this.questions) {
        const category = question.category || 'Uncategorized';
        const serialNumber = question.serial_number
        if (!groups[category]) {
          groups[category] = [];
        }
        groups[category].push(question);
      }
      return groups;
    },

  },
  mounted() {
    this.getQuestions();
    this.getResponses(); 
  },
};
</script>

<style>
  a {
    text-decoration: none;
    color: inherit !important
  }
  .form-wrapper {
    max-width: 70%;
    margin: 0;
  }
  .wrap-text {
    white-space: normal;
    word-wrap: break-word;
  }
  .category {
    font-size: 1.5rem;
    font-weight: 500;
    color: rgb(54, 53, 53) !important;
  }
  .buttonwrapper {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 999;
  }
  .activities:nth-child(odd) {
    background-color: #cccccc;
  }
  .high-risk {
    background-color: #fa273c;
  }
  .v-select__selections {
    font-size: 12px !important; /* Adjust the size as needed */
  }
</style>